import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import AuthLayout from "../../components/layout/AuthLayout"
import FormInput from "../../components/layout/FormInput"
import Button from "../../components/ui/Button"

export default function PasswordReset() {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  })
  const [error, setError] = useState("")
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [countdown, setCountdown] = useState(2)
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    // Reset error when user types
    if (error) setError("")
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // Validate password
    if (formData.password.length < 8) {
      setError("Password must be at least 8 characters long")
      return
    }

    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match")
      return
    }

    // If validation passes, set submitted to true
    setIsSubmitted(true)
  }

  

  return (
    <AuthLayout
      title="Change password"
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="third"
      logoPosition="top"
      textAlignment="default"
    >
      {!isSubmitted ? (
        <>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md">{error}</div>}

          <form className="space-y-4 mt-4 mb-4" onSubmit={handleSubmit}>
            <FormInput
              label="New Password"
              id="password"
              name="password"
              type="password"
              placeholder="At least 8 characters"
              value={formData.password}
              onChange={handleChange}
              required
            />

            <FormInput
              label="Re-enter new password"
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              placeholder="At least 8 characters"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />

            <Button type="submit" variant="login" className="w-full font-bold">
              Confirm Password
            </Button>
          </form>
        </>
      ) : (
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-green-100 rounded-full mx-auto flex items-center justify-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Password changed successfully!</h3>
          <p className="text-sm text-gray-600 mb-4">Your password has been updated.</p>
          {/* <p className="text-sm text-gray-600">
            You will be redirected to the dashboard in <span className="font-bold">{countdown}</span> seconds...
          </p> */}
        </div>
      )}
    </AuthLayout>
  )
}
